/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseApiService from '../baseApi.service';

export default class OcrHistoryService extends BaseApiService {
  readonly basePath: string = 'ocrHistory/v1';
  constructor(props = null) {
    super(props);
  }
}
